import gql from 'graphql-tag';

export const GET_STAGES_BY_DEPARTMENT = gql`
  query GetStagesByDepartment($input: StagesListByDepartmentInput!) {
    bpf {
      stages: stagesByDepartment(input: $input) {
        name
        ordinal
        id: businessProcessFlowStageId
      }
    }
  }
`;
